import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService } from '../Util/Toast/toast.service';
import { SessionService } from '../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonUploadComponent } from '../Component/CommonUpload/common-upload/common-upload.component';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { FormsModule } from '@angular/forms';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { PrequisiteFormComponent } from '../prequisite-form/prequisite-form.component';

@Component({
  selector: 'app-perquisite',
  standalone: true,
  imports: [CommonModule, DataTablesModule, NgbDatepickerModule, FormsModule, LoaderComponent],
  templateUrl: './perquisite.component.html',
  styleUrl: './perquisite.component.scss'
})
export class PerquisiteComponent {

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  user = {} as any;
  isDisabled: boolean = false;
  PerquisiteData = [] as any;
  PerquisiteMasterData = [] as any;
  FromMonth = null as any
  ToMonth = null as any

  constructor(
    private comboload: ComboService,
    public common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private modalService: NgbModal,
    private download: DownloadSampleService,
    private dateFormate: CustomDateParserFormatter,
  ) {
    // this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
    this.user = session.GetUserDetails();
  }

  ngOnInit() {
    // this.PerquisiteTransactionDetailsLoad('PT');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  PerquisiteTransactionDetailsLoad(selectType: any) {
    this.isDisabled = true;
    console.log(this.FromMonth);
    console.log(this.ToMonth);
    this.comboload.PerquisiteTransactionDetailsLoad({
      OperationType: selectType,
      FromMonthYear: this.dateFormate.fullmonth[this.FromMonth.month - 1] + ' ' + this.FromMonth.year,
      ToMonthYear: this.dateFormate.fullmonth[this.ToMonth.month - 1] + ' ' + this.ToMonth.year,
      By: this.user.UserId
    }).subscribe({
      next: (response) => {
        if(selectType == "PM"){
          this.PerquisiteMasterData = response.Table;
          this.download.exportToExcelWithProgress(this.PerquisiteMasterData, "Perquisite Master Data");
          return;
        }
        this.PerquisiteData = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  upload() {
    const modalRef = this.modalService.open(CommonUploadComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Input_ExcelUploadMasterID = 8;
    modalRef.result.then(result => {
      if (result) {
      }
    });
  }

  excelDownload() {
    this.download.exportToExcel(this.PerquisiteData, 'Perquisite Data');
  }

  onNavigate(event: any) {
    this.FromMonth = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  onNavigate2(event: any) {
    this.ToMonth = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  onEditClick(row: any){
    const modalRef = this.modalService.open(PrequisiteFormComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.row = row;
    // modalRef.result.then(result => {
    //   if (result) {
    //   }
    // });    
  }
}
